<script>
import FPTemp1 from "../templates/frontPages/FPTemp1.vue";
import FPTemp2 from "../templates/frontPages/FPTemp2.vue";
import FPTemp3 from "../templates/frontPages/FPTemp3.vue";
import FPTemp4 from "../templates/frontPages/FPTemp4.vue";
import FPTemp5 from "../templates/frontPages/FPTemp5.vue";
import FPTemp6 from "../templates/frontPages/FPTemp6.vue";
import FPTemp7 from "../templates/frontPages/FPTemp7.vue";
import SelectDropdown from "../SelectDropdown.vue";
import StyleBox from "../StyleBox.vue";
import ColorSchemeBox from "../ColorSchemeBox.vue";
import ProjectsDropdown from "../ProjectsDropdown.vue";
import PreviewTemplates from "../PreviewTemplates.vue";
import { isFrontPageReady } from "@/utils/proposalValidation";
import img1 from "@/assets/images/templates/FPTemp1.png";
import img2 from "@/assets/images/templates/FPTemp2.png";
import img3 from "@/assets/images/templates/FPTemp3.png";
import img4 from "@/assets/images/templates/FPTemp4.png";
import img5 from "@/assets/images/templates/FPTemp5.png";
import img6 from "@/assets/images/templates/FPTemp6.png";
import img7 from "@/assets/images/templates/FPTemp7.png";

export default {
  name: "StepFrontPage",
  components: {
    FPTemp1, FPTemp2, FPTemp3, FPTemp4, FPTemp5, FPTemp6, FPTemp7,
    SelectDropdown,
    StyleBox,
    ColorSchemeBox,
    ProjectsDropdown,
    PreviewTemplates,
  },
  props: {
    proposal: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      TemplateList: [
        {
          label: '1- Display proposal details with company logo',
          value: 1,
          preview: img1,
          orientation: "portrait",
          style: this.getTemplateStyle(1)
        },
        {
          label: '2- Display proposal details with company logo and 2 projects',
          value: 2,
          preview: img2,
          orientation: "portrait",
          style: this.getTemplateStyle(2)
        },
        {
          label: '3- Display proposal details with company logo and 4 projects',
          value: 3,
          preview: img3,
          orientation: "portrait",
          style: this.getTemplateStyle(3)
        },
        {
          label: '4- Display proposal details and company logo on gradient banner with project as background',
          value: 4,
          preview: img4,
          orientation: "portrait",
          style: this.getTemplateStyle(4)
        },
        {
          label: '5- Display proposal details, company logo and 1 project in two rows layout with a divider',
          value: 5,
          preview: img5,
          orientation: "portrait",
          style: this.getTemplateStyle(5)
        },
        {
          label: '1- Display proposal details and company and client logos and 1 project in two columns layout',
          value: 6,
          preview: img6,
          orientation: "landscape",
          style: this.getTemplateStyle(6)
        },
        {
          label: '2- Display proposal and company details with logo and 1 project in two columns layout',
          value: 7,
          preview: img7,
          orientation: "landscape",
          style: this.getTemplateStyle(7)
        }
      ]
    };
  },
  computed: {
    isPreviewable() {
      return isFrontPageReady(this.proposal.frontPage);
    }
  },
  methods: {
    getTemplateStyle(t) {
      return {
        colorScheme: {
          header: t == 7 ? "#e3e3e4" : "#181c45",
          body: t == 5 ? "#00bfff" : t == 7 ? "#ffffff" : "#181c45",
          footer: t == 5 || t == 6 ? "#e3e3e4" : t == 3 ? "#00bfff" : t == 7 ? "#000000" : "#181c45",
        },
        heading: {
          color: "#ffffff",
          size: t == 3 || t == 4 ? 22 : t == 5 ? 36 : t == 6 ? 24 : t == 7 ? 14 : 28,
          font: "Arial",
          bold: true,
          italic: false,
          underline: false,
        },
        label: {
          color: t == 1 ? "#000000" : "#ffffff",
          size: t == 3 || t == 4 ? 16 : t == 5 ? 12 : t == 6 ? 24 : t == 7 ? 14 : 20,
          font: "Arial",
          bold: t == 5 || t == 6 ? false : true,
          italic: false,
          underline: false,
        },
        text: {
          color: t == 1 ? "#000000" : t == 7 ? "#a9a7a7" : "#ffffff",
          size: t == 3 || t == 4 ? 16 : t == 5 ? 12 : t == 6 ? 24 : t == 7 ? 14 : 20,
          font: "Arial",
          bold: false,
          italic: false,
          underline: false,
        },
      };
    },
    fixStyling() {
      const match = this.TemplateList.find(item => item.value === this.proposal.frontPage.template);
      if (match) this.proposal.frontPage.style = match.style;
    },
    handleTemplateSelection(template) {
      this.proposal.frontPage.template = template;
      if (template == 1) {
        this.proposal.frontPage.projects = [];
      }
      if (template == 2) {
        this.proposal.frontPage.projects = this.proposal.frontPage.projects.slice(0, 2);
      }
      if (template == 4 || template == 5 || template == 6 || template == 7) {
        this.proposal.frontPage.projects = this.proposal.frontPage.projects.slice(0, 1);
      }
      this.fixStyling();
    },
    handleProjectSelection(projects) {
      this.proposal.frontPage.projects = projects;
    }
  }
};
</script>


<template>
  <div class="d-flex flex-column w-100 bg-white rounded-lg text-left">
    <div class="d-flex flex-column">
      <h4 class="mb-3 font-weight-bold">Front Page</h4>
      <div class="row">
        <div class="col-12 mb-3">
          <SelectDropdown :modelValue="proposal.frontPage.template"
            :options="TemplateList.filter(item => item.orientation === proposal.pageOrientation)"
            placeholder="Select Template" @update:modelValue="handleTemplateSelection" label="Template"
            :isPreviewable="true" />
        </div>
      </div>

      <div class="row">
        <div v-if="proposal.frontPage.template && proposal.frontPage.template !== 1" class="col-12 col-md-6 mb-3">
          <ProjectsDropdown :modelValue="proposal.frontPage.projects" @update:modelValue="handleProjectSelection"
            :maxSelection="proposal.frontPage.template === 2 ? 2 : (proposal.frontPage.template === 4 || proposal.frontPage.template === 5 || proposal.frontPage.template === 6 || proposal.frontPage.template === 7) ? 1 : 4"
            :disabled="!proposal.frontPage.template || proposal.frontPage.template === 1"
            :multi="(proposal.frontPage.template === 4 || proposal.frontPage.template === 5 || proposal.frontPage.template === 6 || proposal.frontPage.template === 7) ? false : true"
            label="Projects" />
        </div>
      </div>

      <div class="row" v-if="proposal.frontPage.template && proposal.frontPage.style">
        <div v-for="item in [
          { key: 'colorScheme', label: 'Color Scheme' },
          { key: 'heading', label: 'Heading Color' },
          { key: 'label', label: 'Label Color' },
          { key: 'text', label: 'Text Color' }
        ]" :key="item.key" class="col-12 col-md-6 col-lg-3 mb-3">
          <ColorSchemeBox v-if="item.key === 'colorScheme'" :styling="proposal.frontPage.style[item.key]"
            :label="item.label" />
          <StyleBox v-else :styling="proposal.frontPage.style[item.key]" :label="item.label" />
        </div>
      </div>
    </div>

    <PreviewTemplates :isPreviewable="isPreviewable" emptyMessage="Select template to preview">
      <FPTemp1 v-if="proposal.frontPage.template === 1" :proposal="proposal.frontPage" />
      <FPTemp2 v-if="proposal.frontPage.template === 2" :proposal="proposal.frontPage" />
      <FPTemp3 v-if="proposal.frontPage.template === 3" :proposal="proposal.frontPage" />
      <FPTemp4 v-if="proposal.frontPage.template === 4" :proposal="proposal.frontPage" />
      <FPTemp5 v-if="proposal.frontPage.template === 5" :proposal="proposal.frontPage" />
      <FPTemp6 v-if="proposal.frontPage.template === 6" :proposal="proposal.frontPage" />
      <FPTemp7 v-if="proposal.frontPage.template === 7" :proposal="proposal.frontPage" />
    </PreviewTemplates>
  </div>
</template>
